/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { useState, useEffect } from "react";
import { FormElement } from "../FormModel/FormElement";

/**
 * Uses form model element and returns its state
 *
 * @param model Form element instance
 */
export function useFormElement<TElement extends FormElement<any> = FormElement<any>>(element: TElement) {

	const [ state, setState ] = useState(() => element.getState());

	useEffect(() => {

		const handleUpdate = () => {
			setState(element.getState());
		};

		element.on("update", handleUpdate);
		handleUpdate();

		return () => {
			element.off("update", handleUpdate);
		};

	}, [ element ]);

	return state as ReturnType<TElement["getState"]>;

}
